import { connect } from 'react-redux';
//
import { updateDealField } from 'store/deal-edit/actions';
import { getDealEvaluation } from 'store/deal-evaluation/actions';
import { IStoreState } from 'store';
import AdditionalMandate from './additional-mandate';
import { getNonStandardRiskData } from './selectors';

const mapStateToProps = (state: IStoreState) => ({
  nonStandardRisksDefault: getNonStandardRiskData(state),
  selectedNonStandardRisk: state.dealEdit.nonstandardRisks,
});

const mapDispatchToProps = {
  updateDealField,
  getDealEvaluation,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalMandate);
